//**auto-generated don't edit this code**//
export enum TestsSortBy {
	None,
	CreateDate,
	TestName,
	ContentArea,
	StateStandard,
	TestOwner,
	NumberOfQuestions,
	Starred,
}